import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=2d74eae0"
import script from "./BaseFormInput.vue?vue&type=script&lang=ts"
export * from "./BaseFormInput.vue?vue&type=script&lang=ts"
import style0 from "./BaseFormInput.vue?vue&type=style&index=0&id=2d74eae0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports